'use strict';

// Creates a menu button that opens a menu of actions
// https://w3c.github.io/aria-practices/#menu
class MenuButtonActions {
  constructor(domNode, actions, triggers, view = 'horizontal') {
    this.domNode = domNode;
    this.performMenuAction = actions.selectMenuItem;
    this.performNodeAction = actions.moveNode;
    this.view = view;
    this.buttonNode = domNode.querySelector('[role="button"]');
    this.menuNode = domNode.querySelector('[role="menu"]');
    this.menuitemNodes = [];
    this.firstMenuitem = false;
    this.lastMenuitem = false;
    this.firstChars = [];

    if (triggers.button.keydown) {
      this.buttonNode.addEventListener(
        'keydown',
        this.onButtonKeydown.bind(this)
      );
    }
    if (triggers.button.click) {
      this.buttonNode.addEventListener('click', this.onButtonClick.bind(this));
    }

    var nodes = domNode.querySelectorAll('[role="menuitem"]');

    for (var i = 0; i < nodes.length; i++) {
      var menuitem = nodes[i];
      this.menuitemNodes.push(menuitem);
      menuitem.tabIndex = -1;
      this.firstChars.push(menuitem.textContent.trim()[0].toLowerCase());

      if (triggers.menu.keydown) {
        menuitem.addEventListener('keydown', this.onMenuitemKeydown.bind(this));
      }
      if (triggers.menu.click) {
        menuitem.addEventListener('click', this.onMenuitemClick.bind(this));
      }
      if (triggers.menu.mouseover) {
        menuitem.addEventListener(
          'mouseover',
          this.onMenuitemMouseover.bind(this)
        );
      }

      if (!this.firstMenuitem) {
        this.firstMenuitem = menuitem;
      }
      this.lastMenuitem = menuitem;
    }

    domNode.addEventListener('focusin', this.onFocusin.bind(this));
    domNode.addEventListener('focusout', this.onFocusout.bind(this));

    window.addEventListener(
      'mousedown',
      this.onBackgroundMousedown.bind(this),
      true
    );
  }

  setFocusToMenuitem(newMenuitem) {
    this.menuitemNodes.forEach(function (item) {
      if (item === newMenuitem) {
        item.tabIndex = 0;
        newMenuitem.focus();
      } else {
        item.tabIndex = -1;
      }
    });
  }

  setFocusToFirstMenuitem() {
    this.setFocusToMenuitem(this.firstMenuitem);
  }

  setFocusToLastMenuitem() {
    this.setFocusToMenuitem(this.lastMenuitem);
  }

  setFocusToPreviousMenuitem(currentMenuitem) {
    var newMenuitem, index;

    if (currentMenuitem === this.firstMenuitem) {
      newMenuitem = this.lastMenuitem;
    } else {
      index = this.menuitemNodes.indexOf(currentMenuitem);
      newMenuitem = this.menuitemNodes[index - 1];
    }

    this.setFocusToMenuitem(newMenuitem);

    return newMenuitem;
  }

  setFocusToNextMenuitem(currentMenuitem) {
    var newMenuitem, index;

    if (currentMenuitem === this.lastMenuitem) {
      newMenuitem = this.firstMenuitem;
    } else {
      index = this.menuitemNodes.indexOf(currentMenuitem);
      newMenuitem = this.menuitemNodes[index + 1];
    }
    this.setFocusToMenuitem(newMenuitem);

    return newMenuitem;
  }

  setFocusByFirstCharacter(currentMenuitem, char) {
    var start, index;

    if (char.length > 1) {
      return;
    }

    char = char.toLowerCase();

    // Get start index for search based on position of currentItem
    start = this.menuitemNodes.indexOf(currentMenuitem) + 1;
    if (start >= this.menuitemNodes.length) {
      start = 0;
    }

    // Check remaining slots in the menu
    index = this.firstChars.indexOf(char, start);

    // If not found in remaining slots, check from beginning
    if (index === -1) {
      index = this.firstChars.indexOf(char, 0);
    }

    // If match was found...
    if (index > -1) {
      this.setFocusToMenuitem(this.menuitemNodes[index]);
    }
  }

  // Popup menu methods

  openPopup() {
    this.menuNode.style.display = 'block';
    this.buttonNode.setAttribute('aria-expanded', 'true');
  }

  closePopup() {
    if (this.isOpen()) {
      this.buttonNode.removeAttribute('aria-expanded');
      this.menuNode.style.display = 'none';
    }
  }

  isOpen() {
    return this.buttonNode.getAttribute('aria-expanded') === 'true';
  }

  // Menu event handlers

  onFocusin() {
    this.domNode.classList.add('focus');
    // for placement
    $('.focus').closest('.placement-item').css('z-index', 3);
  }

  onFocusout() {
    // for placement
    $('.focus').closest('.placement-item').css('z-index', 3);
    this.domNode.classList.remove('focus');
  }

  onButtonKeydown(event) {
    var tgt = event.currentTarget,
      key = event.key,
      flag = false;

    switch (key) {
      case ' ':
      case 'Enter':
        this.openPopup();
        this.setFocusToFirstMenuitem();
        flag = true;
        break;

      case 'Esc':
      case 'Escape':
        this.closePopup();
        flag = true;
        break;

      case 'Up':
      case 'ArrowUp':
        this.upFunctionality(tgt);
        flag = true;
        break;

      case 'ArrowDown':
      case 'Down':
        this.downFunctionality(tgt);
        flag = true;
        break;

      case 'Left':
      case 'ArrowLeft':
        this.leftFunctionality(tgt);
        flag = true;
        break;

      case 'Right':
      case 'ArrowRight':
        this.rightFunctionality(tgt);
        flag = true;
        break;

      default:
        break;
    }

    if (flag) {
      event.stopPropagation();
      event.preventDefault();
    }
  }

  upFunctionality(target) {
    if (this.view === 'vertical') {
      this.performNodeAction(target, 'up');
      this.buttonNode.focus();
    }
  }

  downFunctionality(target) {
    if (this.view === 'vertical') {
      this.performNodeAction(target, 'down');
      this.buttonNode.focus();
    }
  }

  leftFunctionality(target) {
    if (this.view === 'horizontal') {
      this.performNodeAction(target, 'left');
      this.buttonNode.focus();
    }
  }

  rightFunctionality(target) {
    if (this.view === 'horizontal') {
      this.performNodeAction(target, 'right');
      this.buttonNode.focus();
    }
  }

  onButtonClick(event) {
    if (this.isOpen()) {
      this.closePopup();
      this.buttonNode.focus();
    } else {
      this.openPopup();
      this.setFocusToFirstMenuitem();
    }

    event.stopPropagation();
    event.preventDefault();
  }

  onMenuitemKeydown(event) {
    var tgt = event.currentTarget,
      key = event.key,
      flag = false;

    function isPrintableCharacter(str) {
      return str.length === 1 && str.match(/\S/);
    }

    if (event.ctrlKey || event.altKey || event.metaKey) {
      return;
    }

    if (event.shiftKey) {
      if (isPrintableCharacter(key)) {
        this.setFocusByFirstCharacter(tgt, key);
        flag = true;
      }

      if (event.key === 'Tab') {
        this.buttonNode.focus();
        this.closePopup();
        flag = true;
      }
    } else {
      switch (key) {
        case ' ':
        case 'Enter':
          this.closePopup();
          this.performMenuAction(tgt);
          this.buttonNode.focus();
          flag = true;
          break;

        case 'Esc':
        case 'Escape':
          this.closePopup();
          this.buttonNode.focus();
          flag = true;
          break;

        case 'Up':
        case 'ArrowUp':
          this.setFocusToPreviousMenuitem(tgt);
          flag = true;
          break;

        case 'ArrowDown':
        case 'Down':
          this.setFocusToNextMenuitem(tgt);
          flag = true;
          break;

        case 'Home':
        case 'PageUp':
          this.setFocusToFirstMenuitem();
          flag = true;
          break;

        case 'End':
        case 'PageDown':
          this.setFocusToLastMenuitem();
          flag = true;
          break;

        case 'Tab':
          this.closePopup();
          break;

        default:
          if (isPrintableCharacter(key)) {
            this.setFocusByFirstCharacter(tgt, key);
            flag = true;
          }
          break;
      }
    }

    if (flag) {
      event.stopPropagation();
      event.preventDefault();
    }
  }

  onMenuitemClick(event) {
    var tgt = event.currentTarget;
    this.closePopup();
    this.buttonNode.focus();
    this.performMenuAction(tgt);
  }

  onMenuitemMouseover(event) {
    var tgt = event.currentTarget;
    tgt.focus();
  }

  onBackgroundMousedown(event) {
    if (!this.domNode.contains(event.target)) {
      if (this.isOpen()) {
        this.closePopup();
        this.buttonNode.focus();
      }
    }
  }
}

// Initialize menu buttons
window.addEventListener('load-accessible-menu', function (event) {
  var menuButtons = document.querySelectorAll('.accessible-dropdown-trigger');
  for (var i = 0; i < menuButtons.length; i++) {
    new MenuButtonActions(
      menuButtons[i],
      event.detail.actions,
      event.detail.triggers,
      event.detail.view
    );
  }
});
